import lodash from 'lodash';
import moment from 'moment';

import { nodeWithArgs, node } from 'common/util/queryHelper';
import { reportTypes, DATE_FORMAT } from './constants';
import styles from '../containers/ReportContent.scss';

export const documentReportColumns = {
    documentId: { key: 'documentId', label: 'Document ID', filter: 'Filter ID' },
    documentIdentifier: { key: 'documentIdentifier', label: 'Document Identifier', filter: 'Filter Identifier' },
    documentName: { key: 'documentName', label: 'Document Name', filter: 'Filter name' },
    documentUploadedDate: { key: 'documentUploadedDate', label: 'Document Uploaded Date', filter: 'Filter date' },
    uploadedByUserName: { key: 'uploadedByUserName', label: 'Uploaded By User Name', filter: 'Filter user name' },
    uploadedByUserEmail: { key: 'uploadedByUserEmail', label: 'Uploaded By User Email', filter: 'Filter email' },
    conversionStatus: { key: 'conversionStatus', label: 'Conversion Status', filter: 'Filter status' },
    documentStatus: { key: 'documentStatus', label: 'Document Status', filter: 'Filter status' },
    commitDate: { key: 'commitDate', label: 'Commit Date', filter: 'Filter date' },
    commitUserName: { key: 'commitUserName', label: 'Commit User Name', filter: 'Filter user name' },
    commitUserEmail: { key: 'commitUserEmail', label: 'Commit User Email', filter: 'Filter email' },
    documentType: { key: 'documentType', label: 'Document Type', filter: 'Filter type' },
    updatedAt: { key: 'updatedAt', label: 'Updated At', filter: 'Filter date' },
    issueDate: { key: 'issueDate', label: 'Issue Date', filter: 'Filter date' },
    signatureCount: { key: 'signatureCount', label: 'Signature Count', filter: 'Filter number' },
    binderId: { key: 'binderId', label: 'Binder ID', filter: 'Filter ID' },
    binderName: { key: 'binderName', label: 'Uploaded to Binder', filter: 'Filter name' },
};

export const documentReportDefaultColumns = [
    documentReportColumns.documentName.key,
    documentReportColumns.documentUploadedDate.key,
    documentReportColumns.uploadedByUserName.key,
    documentReportColumns.commitDate.key,
    documentReportColumns.commitUserName.key,
    documentReportColumns.documentType.key,
    documentReportColumns.binderName.key,
];

const documentReportColumnValues = lodash.values(documentReportColumns);
export const documentReportColumnsList = lodash.orderBy(documentReportColumnValues, ['label'], ['asc']);

export const getDocumentsReportNode = (args) => {
    return nodeWithArgs('getDocumentsReportRawData', args, [
        node('rows', [
            'binderId',
            'binderName',
            'documentId',
            'documentIdentifier',
            'documentName',
            'documentUploadedDate',
            'documentType',
            'documentStatus',
            'uploadedByUserName',
            'uploadedByUserEmail',
            'issueDate',
            'signatureCount',
            'conversionStatus',
            'commitDate',
            'commitUserName',
            'commitUserEmail',
            'updatedAt'
        ]),
        'count',
    ]);
};

const getDefaultFilter = (collection, name) => {
    const findItem = lodash.find(collection, { fieldName: name });
    return findItem ? findItem.value : '';
};

export const formatMaterialTableDocumentsColumns = (customizeColumns, filters) => {
    return [
        {
            title: documentReportColumns.documentId.label,
            field: documentReportColumns.documentId.key,
            filterPlaceholder: documentReportColumns.documentId.filter,
            hidden: !customizeColumns.includes(documentReportColumns.documentId.key),
            emptyValue: <p className={styles.emptyLabel}>No ID Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.documentId.key),
        },
        {
            title: documentReportColumns.documentIdentifier.label,
            field: documentReportColumns.documentIdentifier.key,
            filterPlaceholder: documentReportColumns.documentIdentifier.filter,
            hidden: !customizeColumns.includes(documentReportColumns.documentIdentifier.key),
            emptyValue: <p className={styles.emptyLabel}>No Identifier Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.documentIdentifier.key),
        },
        {
            title: documentReportColumns.documentName.label,
            field: documentReportColumns.documentName.key,
            filterPlaceholder: documentReportColumns.documentName.filter,
            hidden: !customizeColumns.includes(documentReportColumns.documentName.key),
            emptyValue: <p className={styles.emptyLabel}>No Name Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.documentName.key),
        },
        {
            title: documentReportColumns.documentUploadedDate.label,
            field: documentReportColumns.documentUploadedDate.key,
            filterPlaceholder: documentReportColumns.documentUploadedDate.filter,
            hidden: !customizeColumns.includes(documentReportColumns.documentUploadedDate.key),
            emptyValue: <p className={styles.emptyLabel}>No Date Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.documentUploadedDate.key),
            render: rowData => {
                return moment(rowData[documentReportColumns.documentUploadedDate.key]).format(DATE_FORMAT);
            },
        },
        {
            title: documentReportColumns.uploadedByUserName.label,
            field: documentReportColumns.uploadedByUserName.key,
            filterPlaceholder: documentReportColumns.uploadedByUserName.filter,
            hidden: !customizeColumns.includes(documentReportColumns.uploadedByUserName.key),
            emptyValue: <p className={styles.emptyLabel}>No User name Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.uploadedByUserName.key),
        },
        {
            title: documentReportColumns.uploadedByUserEmail.label,
            field: documentReportColumns.uploadedByUserEmail.key,
            filterPlaceholder: documentReportColumns.uploadedByUserEmail.filter,
            hidden: !customizeColumns.includes(documentReportColumns.uploadedByUserEmail.key),
            emptyValue: <p className={styles.emptyLabel}>No Email Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.uploadedByUserEmail.key),
        },
        {
            title: documentReportColumns.conversionStatus.label,
            field: documentReportColumns.conversionStatus.key,
            filterPlaceholder: documentReportColumns.conversionStatus.filter,
            hidden: !customizeColumns.includes(documentReportColumns.conversionStatus.key),
            emptyValue: <p className={styles.emptyLabel}>No Status Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.conversionStatus.key),
        },
        {
            title: documentReportColumns.documentStatus.label,
            field: documentReportColumns.documentStatus.key,
            filterPlaceholder: documentReportColumns.documentStatus.filter,
            hidden: !customizeColumns.includes(documentReportColumns.documentStatus.key),
            emptyValue: <p className={styles.emptyLabel}>No Status Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.documentStatus.key),
        },
        {
            title: documentReportColumns.commitDate.label,
            field: documentReportColumns.commitDate.key,
            filterPlaceholder: documentReportColumns.commitDate.filter,
            hidden: !customizeColumns.includes(documentReportColumns.commitDate.key),
            defaultFilter: getDefaultFilter(filters, documentReportColumns.commitDate.key),
            emptyValue: <p className={styles.emptyLabel}>No Date Provided</p>,
            render: rowData => {
                return moment(rowData[documentReportColumns.commitDate.key]).format(DATE_FORMAT);
            },
        },
        {
            title: documentReportColumns.commitUserName.label,
            field: documentReportColumns.commitUserName.key,
            filterPlaceholder: documentReportColumns.commitUserName.filter,
            hidden: !customizeColumns.includes(documentReportColumns.commitUserName.key),
            defaultFilter: getDefaultFilter(filters, documentReportColumns.commitUserName.key),
            render: rowData => {
                return !lodash.isEmpty(rowData[documentReportColumns.commitUserName.key]) ? (
                    rowData[documentReportColumns.commitUserName.key]
                ) : (
                    <p className={styles.emptyLabel}>No User name Provided</p>
                );
            },
        },
        {
            title: documentReportColumns.commitUserEmail.label,
            field: documentReportColumns.commitUserEmail.key,
            filterPlaceholder: documentReportColumns.commitUserEmail.filter,
            hidden: !customizeColumns.includes(documentReportColumns.commitUserEmail.key),
            defaultFilter: getDefaultFilter(filters, documentReportColumns.commitUserEmail.key),
            render: rowData => {
                return !lodash.isEmpty(rowData[documentReportColumns.commitUserEmail.key]) ? (
                    rowData[documentReportColumns.commitUserEmail.key]
                ) : (
                    <p className={styles.emptyLabel}>No Name Provided</p>
                );
            },
        },
        {
            title: documentReportColumns.documentType.label,
            field: documentReportColumns.documentType.key,
            filterPlaceholder: documentReportColumns.documentType.filter,
            hidden: !customizeColumns.includes(documentReportColumns.documentType.key),
            emptyValue: <p className={styles.emptyLabel}>No Type Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.documentType.key),
        },
        {

            title: documentReportColumns.updatedAt.label,
            field: documentReportColumns.updatedAt.key,
            filterPlaceholder: documentReportColumns.updatedAt.filter,
            hidden: !customizeColumns.includes(documentReportColumns.updatedAt.key),
            emptyValue: <p className={styles.emptyLabel}>No Date Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.updatedAt.key),
            render: rowData => {
                return moment(rowData[documentReportColumns.updatedAt.key]).format(DATE_FORMAT);
            },
        },
        {
            title: documentReportColumns.issueDate.label,
            field: documentReportColumns.issueDate.key,
            filterPlaceholder: documentReportColumns.issueDate.filter,
            hidden: !customizeColumns.includes(documentReportColumns.issueDate.key),
            emptyValue: <p className={styles.emptyLabel}>No Date Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.issueDate.key),
            render: rowData => {
                return moment(rowData[documentReportColumns.issueDate.key]).format(DATE_FORMAT);
            },
        },
        {
            title: documentReportColumns.signatureCount.label,
            field: documentReportColumns.signatureCount.key,
            filterPlaceholder: documentReportColumns.signatureCount.filter,
            hidden: !customizeColumns.includes(documentReportColumns.signatureCount.key),
            emptyValue: <p className={styles.emptyLabel}>No Number Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.signatureCount.key),
        },
        {
            title: documentReportColumns.binderId.label,
            field: documentReportColumns.binderId.key,
            filterPlaceholder: documentReportColumns.binderId.filter,
            hidden: !customizeColumns.includes(documentReportColumns.binderId.key),
            emptyValue: <p className={styles.emptyLabel}>No ID Provided</p>,
            defaultFilter: getDefaultFilter(filters, documentReportColumns.binderId.key),
        },
        {
            title: documentReportColumns.binderName.label,
            field: documentReportColumns.binderName.key,
            filterPlaceholder: documentReportColumns.binderName.filter,
            hidden: !customizeColumns.includes(documentReportColumns.binderName.key),
            defaultFilter: getDefaultFilter(filters, documentReportColumns.binderName.key),
            render: rowData => {
                return !lodash.isEmpty(rowData[documentReportColumns.binderName.key]) ? (
                    rowData[documentReportColumns.binderName.key]
                ) : (
                    <p className={styles.emptyLabel}>No Name Provided</p>
                );
            },
        }
    ];
};

export const reportDocumentOptionData = {
    name: reportTypes.document,
    displayName: 'Document Reports',
    reportType: reportTypes.document,
    parameters: [
        {
            id: 'institutionId',
            choice: 'institutionId',
            isChoiceRequired: true,
            isChoiceHidden: true,
            label: 'Institution Id',
            type: null,
            source: null,
            dataKey: 'institutionId',
            target: 'institutionId',
            submit: true,
        },
        {
            id: 'all',
            choice: 'documentTypes',
            choiceLabel: 'Choose a list of document types to restrict results to:',
            isChoiceRequired: true,
            label: 'Include all document types',
            type: null,
            source: null,
            target: null,
            submit: false,
        },
        {
            id: 'documentTypes',
            choice: 'documentTypes',
            choiceLabel: 'Choose a list of document types to restrict results to:',
            isChoiceRequired: false,
            label: 'Include only these document types',
            type: 'multiselect',
            source: 'documentTypes',
            dataKey: 'documentTypes',
            target: 'documentTypeIds',
            targetKey: 'key',
            submit: true,
        },
        {
            id: 'all',
            choice: 'binderIds',
            choiceLabel: 'Choose a list of binders to restrict results to:',
            isChoiceRequired: true,
            label: 'Include all binders',
            type: null,
            source: null,
            target: null,
            submit: false,
        },
        {
            id: 'binderIds',
            choice: 'binderIds',
            choiceLabel: 'Choose a list of binders to restrict results to:',
            isChoiceRequired: false,
            label: 'Include only these binders',
            type: 'multiselect',
            source: 'binders',
            dataKey: 'binders',
            target: 'binderIds',
            targetKey: 'key',
            submit: true,
        },
    ],
};
